import React from "react";
import CustomButtton from "../Button/CustomButtton";
import { appleLogoImg, armor, bannerLogoImg, group, homeBackgroundImage, hyperPlayBannerSvg, hyperPlayLogoImg, microsoftLogoImg, mobileHomeBackgroundImage, scrollImg, ultraPlayBannerSvg, ultraPlayLogoImg } from "../../images/general";
import Story from "./Story";
import { constants } from "../../utils/constants";
import { Link } from "gatsby";
import { OutboundLink } from 'gatsby-plugin-gtag'

const HeroSection = () => {
  return (
    <>
      {/** background image set with mobile first approach, sm or greater will have hero.jpg else less than sm i.e mobile */}
      {/* bg-footer is place holder while image is loading */}
      <section
        className="w-full bg-no-repeat bg-cover h-full py-1 bg-footer bg-[url('../images/general/mobilehero.jpg')] sm:bg-[url('../images/general/hero.jpg')]"
      >
        <div className="container mx-auto px-4 sm:py-8">
          <div className="sm:mt-12 md:mt-24 w-full md:w-max md:mr-auto md:ml-56">
            <div className="max-w-full mx-auto md:mx-0 backdrop-blur-[0px] sm:backdrop-blur-[2px] sm:-mb-[4rem]">
              <img src={bannerLogoImg} alt="banner-logo" className="sm:mb-8 sm:pb-0 sm:pt-0 pb-96 pt-16 sm:w-full w-[209px] sm:mx-0 mx-auto"                
                  data-sal="fade-in"
                  data-sal-delay="400"
                  data-sal-easing="ease"/>
              <div>
              <p 
              className="font-cinzel font-bold text-lg md:text-2xl leading-6 text-customgrey pb-6 text-center sm:w-3/4 w-3/5  mx-auto bg-text-shadow"
              data-sal="fade-in"
              data-sal-delay="500"
              data-sal-easing="ease">
                Download now and forge legends.
              </p>
              </div>
              <div className="hidden sm:flex flex-col"
                                              data-sal="fade-in"
                                              data-sal-delay="600"
                                              data-sal-easing="ease">
              <div className="flex space-x-0 md:space-x-4 justify-between">
                <OutboundLink href={constants.windows_client} target="_blank">
                <CustomButtton
                  text="Download for Windows"
                  icon1={microsoftLogoImg}
                  icon2={group}
                />
                </OutboundLink> 
                <OutboundLink href={constants.mac_client} target="_blank">
                <CustomButtton
                  text={<span className="w-[9.5rem]">Download for Mac</span>}
                  icon1={appleLogoImg}
                  icon2={group}
                />
                </OutboundLink>
              </div>
              <p 
              className="font-cinzel font-bold text-lg md:text-2xl leading-6 text-customgrey text-center sm:w-3/4 w-3/5  mx-auto bg-text-shadow mt-6 mb-4">
                Play On
              </p>
              <div className="flex space-x-0 md:space-x-4 justify-center">
                <OutboundLink href={constants.hyperplay_download} target="_blank">
                <CustomButtton
                  text={<img src={hyperPlayBannerSvg} className="w-32 mx-6 h-[1.8rem]"/>}
                  btnType="blackGold"
                />
                </OutboundLink> 
                <OutboundLink href={constants.ultraplay_download} target="_blank">
                <CustomButtton
                  text={<img src={ultraPlayBannerSvg} className="w-32 mx-6 h-[1.8rem]"/>}
                  btnType="blackGold"
                />
                </OutboundLink>
              </div>
              </div>
              <div className="sm:hidden block">
              <Link to={constants.app_routes.login}>
                <CustomButtton
                  text="Play Now"
                  icon1={armor}
                  icon2={group}
                />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto w-5/6 p-1 md:pt-8 md:pb-40">
          <img
            src={scrollImg}
            alt=""
            className="sm:block hidden w-28 md:w-48 cursor-pointer mx-auto focus:outline-none animate-spin-slow"
          />
        </div>
      </section>
      <Story />
    </>
  );
};

export default HeroSection;
